import { alpha, useTheme } from '@rossum/ui/material';
import { useDrawingArea, useXScale, useYScale } from '@rossum/ui/x-charts-pro';
import { AutomationAssistantRates } from '../../core/types';

type GradientLayerProps = {
  currentState: AutomationAssistantRates;
  selectedState: AutomationAssistantRates;
};
export const automationGradientId = 'automation-gradient';

export const CustomGradientLayer = ({
  currentState,
  selectedState,
}: GradientLayerProps) => {
  const theme = useTheme();
  const { top, height } = useDrawingArea();
  const xScale = useXScale();
  const yScale = useYScale();

  // Get coordinates for both points
  const currentX = xScale(currentState.precisionTarget);
  const currentY = yScale(currentState.automationRate);
  const selectedX = xScale(selectedState.precisionTarget);
  const selectedY = yScale(selectedState.automationRate);

  // Check if all coordinates are valid
  if (
    typeof currentX !== 'number' ||
    typeof currentY !== 'number' ||
    typeof selectedX !== 'number' ||
    typeof selectedY !== 'number'
  ) {
    return null;
  }

  // Calculate the distance between points

  return (
    <g clipPath="url('#clipped')">
      <defs>
        <linearGradient
          id={automationGradientId}
          x1={currentX}
          y1={currentY}
          x2={selectedX}
          y2={currentY}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor={alpha(theme.palette.primary.main, 0)} />

          <stop
            offset="100%"
            stopColor={alpha(theme.palette.primary.main, 0.2)}
          />
        </linearGradient>
      </defs>

      {/* Create a filled rectangular area between the two points */}
      <path
        id={automationGradientId}
        d={`
          M ${currentX} ${top}
          L ${selectedX} ${top}
          L ${selectedX} ${height + top}
          L ${currentX} ${height + top}
          Z
        `}
        fill={`url(#${automationGradientId})`}
      />
    </g>
  );
};
